import React from 'react';
import { FieldActionsContext } from '../../../../contexts/field-actions-context';
import { FieldValidationContext } from '../../../../contexts/field-validation-context';
import { FormContext } from '../../../../contexts/form-context';
import { FormValuesContext } from '../../../../contexts/form-values-context';
import { FormViewContext } from '../../../../contexts/form-view-context';
import { FormFieldsContext } from '../../contexts/form-fields-context';
import { FormField } from './form-field';
export const createFormFields = ({ form, errors, values, onFieldChange, onBlur, onFocus, FieldLayout, formSchema, validateFields, fields, fieldActions })=>{
    return form.fields.map((formField)=>{
        const component = /*#__PURE__*/ React.createElement(FormContext.Provider, {
            value: formSchema
        }, /*#__PURE__*/ React.createElement(FormFieldsContext.Provider, {
            value: fields
        }, /*#__PURE__*/ React.createElement(FieldActionsContext.Provider, {
            value: fieldActions
        }, /*#__PURE__*/ React.createElement(FieldValidationContext.Provider, {
            value: {
                validateFields
            }
        }, /*#__PURE__*/ React.createElement(FormViewContext.Provider, {
            value: form
        }, /*#__PURE__*/ React.createElement(FormValuesContext.Provider, {
            value: values
        }, /*#__PURE__*/ React.createElement(FormField, {
            key: formField.id,
            field: formField,
            values: values,
            errors: errors,
            onBlur: onBlur,
            onFocus: onFocus,
            onFieldChange: onFieldChange,
            FieldLayout: FieldLayout
        })))))));
        return {
            id: formField.id,
            fieldType: formField.fieldType,
            component,
            layout: formField.layout
        };
    }).filter((item)=>!!item);
};

//# sourceMappingURL=create-form-fields.js.map